module.exports = __webpack_public_path__ + "img/shangou.53754e13.png";